export class CreateDriverByRiderTypeModel {
	FirstName: string;
	LastName: string;
	PhoneCountryCode: string;
	PhoneBody: string;
	Email: string;
	IsEVDriver: boolean;

	constructor(payload?: { [key: string]: any }) {
		this.FirstName = '';
		this.LastName = '';
		this.PhoneCountryCode = '+63';
		this.PhoneBody = '';
		this.Email = '';
		this.IsEVDriver = false;
		Object.assign(this, payload);
	}

	get Phone(): string {
		return this.PhoneCountryCode + this.PhoneBody;
	}

	public IsAllFieldsFilled(): boolean {
		if (this.FirstName && this.LastName &&
			this.PhoneCountryCode && this.PhoneBody) {
			return true;
		}

		return false;
	}

	toJSON() {
		return {
			FirstName: this.FirstName,
			LastName: this.LastName,
			Email: this.Email,
			Phone: this.Phone,
			IsEVDriver: this.IsEVDriver
		};
	}
}
